// Currency units data for conversion routes
// Using real-time exchange rates from frankfurter.app (ECB rates)

export const currencyUnits = [
  { id: 'usd', name: 'US Dollar', symbol: 'USD', plural: 'US Dollars', code: 'USD' },
  { id: 'eur', name: 'Euro', symbol: 'EUR', plural: 'Euros', code: 'EUR' },
  { id: 'gbp', name: 'British Pound', symbol: 'GBP', plural: 'British Pounds', code: 'GBP' },
  { id: 'jpy', name: 'Japanese Yen', symbol: 'JPY', plural: 'Japanese Yen', code: 'JPY' },
  { id: 'cad', name: 'Canadian Dollar', symbol: 'CAD', plural: 'Canadian Dollars', code: 'CAD' },
  { id: 'aud', name: 'Australian Dollar', symbol: 'AUD', plural: 'Australian Dollars', code: 'AUD' },
  { id: 'chf', name: 'Swiss Franc', symbol: 'CHF', plural: 'Swiss Francs', code: 'CHF' },
  { id: 'cny', name: 'Chinese Yuan', symbol: 'CNY', plural: 'Chinese Yuan', code: 'CNY' },
  { id: 'inr', name: 'Indian Rupee', symbol: 'INR', plural: 'Indian Rupees', code: 'INR' },
  { id: 'mxn', name: 'Mexican Peso', symbol: 'MXN', plural: 'Mexican Pesos', code: 'MXN' },
  { id: 'brl', name: 'Brazilian Real', symbol: 'BRL', plural: 'Brazilian Reais', code: 'BRL' },
  { id: 'krw', name: 'South Korean Won', symbol: 'KRW', plural: 'South Korean Won', code: 'KRW' },
  { id: 'sgd', name: 'Singapore Dollar', symbol: 'SGD', plural: 'Singapore Dollars', code: 'SGD' },
  { id: 'hkd', name: 'Hong Kong Dollar', symbol: 'HKD', plural: 'Hong Kong Dollars', code: 'HKD' },
  { id: 'sek', name: 'Swedish Krona', symbol: 'SEK', plural: 'Swedish Kronor', code: 'SEK' },
  { id: 'nok', name: 'Norwegian Krone', symbol: 'NOK', plural: 'Norwegian Kroner', code: 'NOK' },
  { id: 'dkk', name: 'Danish Krone', symbol: 'DKK', plural: 'Danish Kroner', code: 'DKK' },
  { id: 'nzd', name: 'New Zealand Dollar', symbol: 'NZD', plural: 'New Zealand Dollars', code: 'NZD' },
  { id: 'zar', name: 'South African Rand', symbol: 'ZAR', plural: 'South African Rand', code: 'ZAR' },
  { id: 'pln', name: 'Polish Zloty', symbol: 'PLN', plural: 'Polish Zloty', code: 'PLN' },
  { id: 'thb', name: 'Thai Baht', symbol: 'THB', plural: 'Thai Baht', code: 'THB' },
  { id: 'idr', name: 'Indonesian Rupiah', symbol: 'IDR', plural: 'Indonesian Rupiah', code: 'IDR' },
  { id: 'myr', name: 'Malaysian Ringgit', symbol: 'MYR', plural: 'Malaysian Ringgit', code: 'MYR' },
  { id: 'php', name: 'Philippine Peso', symbol: 'PHP', plural: 'Philippine Pesos', code: 'PHP' },
  { id: 'czk', name: 'Czech Koruna', symbol: 'CZK', plural: 'Czech Koruna', code: 'CZK' },
  { id: 'huf', name: 'Hungarian Forint', symbol: 'HUF', plural: 'Hungarian Forint', code: 'HUF' },
  { id: 'ils', name: 'Israeli Shekel', symbol: 'ILS', plural: 'Israeli Shekels', code: 'ILS' },
  { id: 'try', name: 'Turkish Lira', symbol: 'TRY', plural: 'Turkish Lira', code: 'TRY' },
  { id: 'ron', name: 'Romanian Leu', symbol: 'RON', plural: 'Romanian Lei', code: 'RON' },
  { id: 'bgn', name: 'Bulgarian Lev', symbol: 'BGN', plural: 'Bulgarian Leva', code: 'BGN' },
  { id: 'isk', name: 'Icelandic Krona', symbol: 'ISK', plural: 'Icelandic Kronur', code: 'ISK' },
];

// Popular conversions
export const popularCurrencyConversions = [
  { from: 'usd', to: 'eur' },
  { from: 'eur', to: 'usd' },
  { from: 'usd', to: 'gbp' },
  { from: 'gbp', to: 'usd' },
  { from: 'usd', to: 'jpy' },
  { from: 'jpy', to: 'usd' },
  { from: 'usd', to: 'cad' },
  { from: 'cad', to: 'usd' },
  { from: 'usd', to: 'aud' },
  { from: 'aud', to: 'usd' },
  { from: 'eur', to: 'gbp' },
  { from: 'gbp', to: 'eur' },
  { from: 'usd', to: 'inr' },
  { from: 'inr', to: 'usd' },
  { from: 'usd', to: 'cny' },
  { from: 'cny', to: 'usd' },
  { from: 'eur', to: 'chf' },
  { from: 'chf', to: 'eur' },
  { from: 'usd', to: 'mxn' },
  { from: 'mxn', to: 'usd' },
  { from: 'usd', to: 'brl' },
  { from: 'brl', to: 'usd' },
  { from: 'usd', to: 'krw' },
  { from: 'krw', to: 'usd' },
];

// Generate all possible conversion pairs
export const generateAllCurrencyConversions = () => {
  const conversions = [];
  for (const fromUnit of currencyUnits) {
    for (const toUnit of currencyUnits) {
      if (fromUnit.id !== toUnit.id) {
        conversions.push({
          from: fromUnit.id,
          to: toUnit.id,
          fromUnit,
          toUnit,
          slug: `${fromUnit.id}-to-${toUnit.id}`,
        });
      }
    }
  }
  return conversions;
};

// Get currency by ID
export const getCurrencyById = (id) => {
  return currencyUnits.find(unit => unit.id === id);
};

// Cache for exchange rates
let ratesCache = {
  rates: null,
  base: null,
  timestamp: null,
  date: null
};

// Cache duration: 1 hour (in milliseconds)
const CACHE_DURATION = 60 * 60 * 1000;

// Fetch exchange rates from frankfurter.app API
export const fetchExchangeRates = async (baseCurrency = 'EUR') => {
  const now = Date.now();

  // Return cached rates if still valid
  if (ratesCache.rates &&
      ratesCache.base === baseCurrency &&
      ratesCache.timestamp &&
      (now - ratesCache.timestamp) < CACHE_DURATION) {
    return {
      rates: ratesCache.rates,
      date: ratesCache.date,
      cached: true
    };
  }

  try {
    const response = await fetch(`https://api.frankfurter.app/latest?from=${baseCurrency}`);

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    const data = await response.json();

    // Add the base currency itself with rate 1
    const rates = { ...data.rates, [baseCurrency]: 1 };

    // Update cache
    ratesCache = {
      rates,
      base: baseCurrency,
      timestamp: now,
      date: data.date
    };

    return { rates, date: data.date, cached: false };
  } catch (error) {
    console.error('Error fetching exchange rates:', error);

    // Return cached data if available, even if expired
    if (ratesCache.rates && ratesCache.base === baseCurrency) {
      return {
        rates: ratesCache.rates,
        date: ratesCache.date,
        cached: true,
        error: error.message
      };
    }

    throw error;
  }
};

// Convert between currencies using live rates
export const convertCurrencyLive = async (value, fromId, toId) => {
  const fromUnit = getCurrencyById(fromId);
  const toUnit = getCurrencyById(toId);

  if (!fromUnit || !toUnit) return null;

  try {
    // Fetch rates with EUR as base (frankfurter.app uses EUR by default)
    const { rates, date } = await fetchExchangeRates('EUR');

    const fromRate = rates[fromUnit.code];
    const toRate = rates[toUnit.code];

    if (!fromRate || !toRate) {
      throw new Error(`Rate not available for ${fromUnit.code} or ${toUnit.code}`);
    }

    // Convert: value in fromCurrency -> EUR -> toCurrency
    const eurValue = value / fromRate;
    const result = eurValue * toRate;

    return { result, date };
  } catch (error) {
    console.error('Currency conversion error:', error);
    return null;
  }
};

// Synchronous convert for Quick Reference Table (uses cached rates)
export const convertCurrency = (value, fromId, toId, rates = null) => {
  if (!rates) {
    // Fallback: return null if no rates provided
    // The component should use convertCurrencyLive for actual conversions
    return null;
  }

  const fromUnit = getCurrencyById(fromId);
  const toUnit = getCurrencyById(toId);

  if (!fromUnit || !toUnit) return null;

  const fromRate = rates[fromUnit.code];
  const toRate = rates[toUnit.code];

  if (!fromRate || !toRate) return null;

  const eurValue = value / fromRate;
  return eurValue * toRate;
};

// Format conversion slug to readable text
export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

// Generate SEO description
export const generateSEODescription = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural} with live exchange rates. Free online currency converter using real-time ECB rates updated daily.`;
};

// Get rate update date
export const getRateDate = () => {
  return ratesCache.date;
};
